<template>
  <div class="header-container" v-if="getPipes">
    <AppTitle />
    <div class="user-badge">
      <UserBadge />
    </div>
  </div>
  <div class="delta-container" v-if="getPipes">
    <div class="delta">
      <DeltaDisplay :type="'pressure'" />
    </div>
    <div class="delta-ui-bar">
      <GraphSelection />
      <Calculations />
      <PipeMenu />
      <div class="sprinkler-selection">
        <SprinklerSelection />
      </div>
      <div class="app-rate-container">
        <label style="font-weight: bold;">Total Flow</label>
        <div class="app-rate">
          {{ getTotalFlow }}
        </div>
        <div class="app-rate-unit">
          {{ getTotalFlowUnit }}
        </div>
      </div>
      <PrintButton />
      <ClearButton />
    </div>
    <div class="delta">
      <DeltaDisplay :type="'flow'" />
    </div>
  </div>
  <OffsetContainer v-if="getPipes" />
  <div class="pressure-flow-container" v-if="getPipes">
    <ChartAxisLabel side="left" :label="'Sprinkler Pressure (' + pressureUnit + ')'" />
    <div class="pressure-flow-chart">
      <PressureFlowChart />
    </div>
    <ChartAxisLabel side="right" :label="'Sprinkler Flow (' + flowUnit + ')'" />
  </div>
  <div class="chart-divider"
       @mousedown="handleCDMouseDown"
       @touchstart="handleCDMouseDown"
  ></div>
  <div class="pipe-slope-container" v-if="getPipes">

    <div class="spacing-offset">
      <LayoutInfo :side="'left'" />
    </div>
    <div class="pipe-layout">
      <ContextMenu />
      <LayoutSegmentHolder :type="'pipe'" />
      <InletBar/>
      <PipeEditor />
      <LayoutSegmentHolder :type="'slope'" />
    </div>
    <div class="spacing-offset">
      <LayoutInfo :side="'right'" />
    </div>
  </div>
  <BottomBar v-if="getPipes" />
  <PrintPopup/>
</template>

<script>
import BottomBar from '@/components/BottomBar';
import Calculations from '@/components/Calculations.vue';
import ContextMenu from '@/components/layout/ContextMenu';
import DeltaDisplay from '@/components/DeltaDisplay.vue';
import GraphSelection from '@/components/GraphSelection.vue';
import LayoutInfo from '@/components/layout/LayoutInfo';
import LayoutSegmentHolder from '@/components/layout/LayoutSegmentHolder.vue';
import PipeEditor from '@/components/layout/pipe_editor/PipeEditor';
import PressureFlowChart from '@/components/layout/pressure_flow_chart/PressureFlowChart.vue';
import SprinklerSelection from '@/components/SprinklerSelection.vue';
import AppTitle from '@/components/AppTitle.vue';
import UserBadge from '@/components/UserBadge.vue';
import PipeEdit from '@/components/pipe/PipeEdit';
import { usePipeStore } from '@/store/PipeStore';
import OffsetContainer from '@/components/OffsetContainer';
import ChartAxisLabel from '@/components/layout/pressure_flow_chart/ChartAxisLabel';
import { useInputStore } from '@/store/InputStore';
import { useSettingsStore } from '@/store/SettingsStore';
import * as UnitConversion from '../services/UnitConversionService';
import PrintPopup from '../components/print/PrintPopup.vue';
import PrintButton from '../components/layout/menu/PrintButton.vue';
import ClearButton from '../components/layout/menu/ClearButton.vue';
import InletBar from '../components/layout/pipe_editor/InletBar.vue';
import { useSegmentStore } from '@/store/SegmentStore';
import PipesButton from '@/components/layout/menu/PipesButton.vue';
import PipeMenu from '@/components/PipeMenu.vue';


export default {
  components: {
    PrintPopup,
    PipeEdit,
    BottomBar,
    OffsetContainer,
    Calculations,
    ContextMenu,
    DeltaDisplay,
    GraphSelection,
    LayoutInfo,
    LayoutSegmentHolder,
    PipeEditor,
    PressureFlowChart,
    SprinklerSelection,
    AppTitle,
    UserBadge,
    ChartAxisLabel,
    PrintButton,
    ClearButton,
    InletBar,
    PipesButton,
    PipeMenu
  },
  setup () {
    usePipeStore().getPipesData();
    useSegmentStore().createPatterns();
  },
  data () {
    return {
      dividerStartY: 0,
      dividerY: 0,
      pfcStartHeight: 0,
      pscStartHeight: 0,
      ratio: 1
    };
  },
  mounted () {
    window.addEventListener('resize', this.handleResize);

  },
  computed: {
    getPipes () {
      return usePipeStore().getPipes;
    },
    getTotalFlow () {
      return this.filterTotalFlow(useInputStore().getCalcData.totalFlow);
    },
    getTotalFlowUnit () {
      return useSettingsStore().getFlowUnit;
    },
    IsShow () {
      return useSettingsStore().IsFlush;
    },
    getHeightWithoutHeaderAndFooter () {
      let hc = document.getElementsByClassName('header-container')[0]  ;
      let dc = document.getElementsByClassName('delta-container')[0];
      let och = document.getElementsByClassName('offset-container-holder')[0];
      let footer = document.getElementsByClassName('footer')[0];
      return (
        (hc?.clientHeight || 0) +
        (dc?.clientHeight || 0) +
        (och?.clientHeight || 0) +
        (footer?.clientHeight || 0)
      );
    },
    pressureUnit () {
      return useSettingsStore().getPressureUnit;
    },
    flowUnit () {
      return useSettingsStore().getFlowUnit;
    }
  },
  methods: {
    filterTotalFlow (appRate) {
      return (UnitConversion.FilterFlow(appRate, this.getTotalFlowUnit)).toFixed(2);
    },
    handleCDMouseDown (e) {
      this.$data.dividerStartY = e.touches ? e.touches[0].clientY : e.clientY;
      let pfc = document.getElementsByClassName('pressure-flow-container')[0];
      this.$data.pfcStartHeight = pfc.clientHeight;
      let psc = document.getElementsByClassName('pipe-slope-container')[0];
      this.$data.pscStartHeight = psc.clientHeight;
      const moveEvent = e.touches ? 'touchmove' : 'mousemove';
      const endEvent = e.touches ? 'touchend' : 'mouseup';
      window.addEventListener(moveEvent, this.handleCDMouseMove);
      window.addEventListener(endEvent, this.handleCDMouseUp);
    },
    handleCDMouseMove (e) {
      if (e) {
        this.$data.dividerY = e.touches ? e.touches[0].clientY : e.clientY;
      }
      let difY = (!e) ? 0 : this.$data.dividerY - this.$data.dividerStartY;
      let pfc = document.getElementsByClassName('pressure-flow-container')[0];
      let psc = document.getElementsByClassName('pipe-slope-container')[0];
      let pfcMaxHeight = (this.$data.pfcStartHeight  +  difY);
      if (!e) { pfcMaxHeight = pfc.clientHeight; }

      // calculate ratio
      let ratio = pfcMaxHeight / (pfc.clientHeight + psc.clientHeight);
      if (!e) { ratio = this.$data.ratio; }
      this.$data.ratio = ratio;
      let remainingHeight = (window.innerHeight - this.getHeightWithoutHeaderAndFooter);
      pfc.style.maxHeight = ((ratio*remainingHeight) ) + 'px';
      psc.style.maxHeight = (remainingHeight - (ratio*remainingHeight) - 8) + 'px';
    },
    handleCDMouseUp () {
      ['mousemove', 'mouseup', 'touchmove', 'touchend'].forEach(event =>
        window.removeEventListener(event, event.includes('move') ? this.handleCDMouseMove : this.handleCDMouseUp)
      );
    },
    handleResize () {
      this.handleCDMouseMove(null);
    }
  }
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .nelson-logo {
    height: 30px !important;
    width: auto !important;
  }
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.delta-container {
  display: flex;
  justify-content: space-between;
}
.delta {
  flex: 1;
  min-width: 200px;
  max-width: 300px;
}
.menu-bar {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.sprinkler-selection {
  display: flex;
  flex-direction: row;
  text-align: center;
}
.pressure-flow-container {
  display: flex;
  flex: 1;
  min-height: 200px;
}
.pressure-axis-label {
  background-color: var(--pressure-color);
  color: white;
  height: 150px;
  margin: auto auto auto 0px;
  text-align: center;
  transform: rotate(180deg);
  user-select: none;
  writing-mode: vertical-lr;
}
.pressure-flow-chart {
  display: flex;
  width: 80%;
}
.pipe-slope-container {
  display: flex;
  flex: 1;
  justify-content: center;
  height: 50%;
  min-height: 386px;
}
.pipe-layout {
  display: flex;
  flex-direction: column;
  width: 80%;
  max-width: calc(100% - 160px);
}
.app-rate-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #F6F6F6;
  font-size: 70%;
  width: 100px;
  height: 100%;
}
.delta-ui-bar {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex: 1;
}
.chart-divider {
  width: 100%;
  height: 8px;
  background-color: lightgray;
  border-top: 1px solid gray;
  cursor: ns-resize;
  transition: .2s;
}
.chart-divider:hover {
  background-color: #b4b4b4;
}
</style>

<style>
.spacing-offset {
  text-align: center;
  width: 10%;
  min-width: 80px;
}
</style>